import React from "react";
import "./HeroContainer.css";
// import {
//   Link
// } from 'react-router-dom'
// import background from "./hero_background.jpg";
import appImage from "./app.png";
import appleStore from "./appstore.png";
import playStore from "./playstore.png";

// import "../../assets/css/materialize.css"
// import "../../assets/css/style.css"

const HeroContainer = () => {
  return (
    <div className="hero-bg">
      <div className="container">
        <div className="section">
          <div className="row">
            <div className="col s6 m6">
              <h3 className=" header-text" style={{ color: "#373435" }}>
                Quality and affordable healthcare in your mobile phone.
              </h3>
              <h5
                className="header header-small-text"
                style={{ color: "#9EA6AB" }}
              >
                Get professional medical consultation, Personalized health care
                management tool, Easy to read Lab results, Download medical
                records in seconds, Order for lab online, etc.
              </h5>
              <div className="row">
                <div className="col m6">
                  <img
                    src={appleStore}
                    height="40"
                    width="140"
                    alt="apple store"
                  />
                </div>
                <div className="col m6">
                  <img
                    src={playStore}
                    height="40"
                    width="140"
                    alt="play store"
                  />
                </div>
              </div>
            </div>
            <div className="col m6 center appImg">
              <img src={appImage} alt="Phone Img" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroContainer;
